var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecruitingStagesSlider = function SvgRecruitingStagesSlider(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    fill: "#FFA0A0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 0 0 64h128L64 0ZM64 64 0 128h128L64 64Z"
  }))));
};
export default SvgRecruitingStagesSlider;